// extracted by mini-css-extract-plugin
export default {"rating":"BK-z","numberOfStars":"CK-z","count":"DK-z","barGraphSpacing":"EK-z","barGraph":"FK-z"};